export const PRODUCT_MACHINE_ID = 'productMachine';

export const productsMachineStates = {
  getProductConfigState: 'getProductConfigState',
  getReferralCodeDetailState: 'getReferralCodeDetailState',
  getCouponCodeDetailState: 'getCouponCodeDetailState',
  getSelectedProductPaymentServiceState:
    'getSelectedProductPaymentServiceState',
  getOrderStatusState: 'getOrderStatusState',
  createPaymentOrderAndGetDetailState: 'createPaymentOrderAndGetDetailState',
  cancelPaymentOrderState: 'cancelPaymentOrderState',
  getPaymentAuthCodeState: 'getPaymentAuthCodeState',
  getPaymentsClientAuthenticationDetailsState:
    'getPaymentsClientAuthenticationDetailsState',
  getUserOrdersDetailsState: 'getUserOrdersDetailsState',
  getProductReferralCodesState: 'getProductReferralCodesState',
  trackReferralAttemptState: 'trackReferralAttemptState',
  getOrCreateApplicationSectionVisitState:
    'getOrCreateApplicationSectionVisitState',
  executeSectionActionState: 'executeSectionActionState',
  newOfferUnlockedState: 'newOfferUnlockedState'
};

export const productMachineActions = {
  onSuccessGetProductConfig: 'onSuccessGetProductConfig',
  updateParentContextValue: 'updateParentContextValue',
  onSuccessGetReferralCodeDetail: 'onSuccessGetReferralCodeDetail',
  onErrorGetReferralCodeDetail: 'onErrorGetReferralCodeDetail',
  onSuccessGetCouponCodeDetail: 'onSuccessGetCouponCodeDetail',
  onErrorGetCouponCodeDetail: 'onErrorGetCouponCodeDetail',
  resetErrorMessageAndApiStatus: 'resetErrorMessageAndApiStatus',
  onSuccessGetSelectedProductPaymentServices:
    'onSuccessGetSelectedProductPaymentServices',
  onSuccessCreatePaymentOrderAndGetDetail:
    'onSuccessCreatePaymentOrderAndGetDetail',
  onErrorCreatePaymentOrderAndGetDetail:
    'onErrorCreatePaymentOrderAndGetDetail',
  onSuccessCancelPaymentOrder: 'onSuccessCancelPaymentOrder',
  onSuccessGettingPaymentStatus: 'onSuccessGettingPaymentStatus',
  onFailGettingPaymentStatus: 'onFailGettingPaymentStatus',
  onSuccessGettingPaymentsClientAuthenticationDetails:
    'onSuccessGettingPaymentsClientAuthenticationDetails',
  onSuccessGettingPaymentAuthCode: 'onSuccessGettingPaymentAuthCode',
  handleErrorOnFailureGetClientConfigDetails:
    'handleErrorOnFailureGetClientConfigDetails',
  onSuccessGettingUserOrdersDetails: 'onSuccessGettingUserOrdersDetails',
  onSuccessGetOrCreateApplicationSectionVisit:
    'onSuccessGetOrCreateApplicationSectionVisit',
  onSuccessExecuteSection: 'onSuccessExecuteSection',
  onSuccessGetProductReferralCodes: 'onSuccessGetProductReferralCodes',
  onErrorTrackReferralAttemptLogEntry: 'onErrorTrackReferralAttemptLogEntry'
};

export const productMachineEvents = {
  onClickContinueToPay: 'ON_CLICK_CONTINUE_TO_PAY',
  cancelPaymentOrder: 'CANCEL_PAYMENT_ORDER',
  getPaymentStatus: 'GET_PAYMENT_STATUS',
  resetErrorMessageAndApiStatus: 'RESET_ERROR_MESSAGE_AND_API_STATUS',
  getReferralCodeDetail: 'GET_REFERRAL_CODE_DETAIL',
  getCouponCodeDetails: 'GET_COUPON_CODE_DETAILS',
  executeSectionAction: 'EXECUTE_SECTION_ACTION',
  modifyOrderDetails: 'MODIFY_ORDER_DETAILS',
  getProductDetails: 'GET_PRODUCT_DETAILS'
};

export const productMachineGuards = {
  isProductAmountToBePaidZero: 'isProductAmountToBePaidZero',
  isUserAlreadyHaveAccessToCoupon: 'isUserAlreadyHaveAccessToCoupon',
  isProductFeeBasedOnTimer: 'isProductFeeBasedOnTimer',
  isProductFeeBasedOnTimerAndCouponExpired:
    'isProductFeeBasedOnTimerAndCouponExpired',
  shouldTrackSecondaryReferralAttempt: 'shouldTrackSecondaryReferralAttempt',
  isLicenceCodeCarryForwardConfigNotFound:
    'isLicenceCodeCarryForwardConfigNotFound'
};

export const productMachineServices = {
  getProductConfig: 'getProductConfig',
  getReferralCodeDetail: 'getReferralCodeDetail',
  getSelectedProductPaymentService: 'getSelectedProductPaymentService',
  createPaymentOrderAndGetDetail: 'createPaymentOrderAndGetDetail',
  getOrderStatus: 'getOrderStatus',
  cancelPaymentOrder: 'cancelPaymentOrder',
  getPaymentAuthCode: 'getPaymentAuthCode',
  getPaymentClientAuthenticationDetails:
    'getPaymentClientAuthenticationDetails',
  getUserOrdersDetails: 'getUserOrdersDetails',
  getProductReferralCodes: 'getProductReferralCodes',
  trackReferralAttempt: 'trackReferralAttempt',
  getOrCreateApplicationSectionVisit: 'getOrCreateApplicationSectionVisit',
  executeSectionAction: 'executeSectionAction',
  updateUserOrderExtraInfo: 'updateUserOrderExtraInfo'
};
